import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    async certificateSms(certificateId, data) {
        const res = await Axios.post(
            `${baseURL}record/certificate/${certificateId}/sms`,
            data
        );

        return res.data.response;
    },
    async certificateEmail(certificateId, data) {
        const res = await Axios.post(
            `${baseURL}record/certificate/${certificateId}/email`,
            data
        );

        return res.data.response;
    },
    bulkDelete(params) {
        return Axios.post(
            `${baseURL}record/certificate/bulk-delete`,
            params
        ).then(res => {
            if (res && res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    }
};
